interface RatingStarProps {
	size?: number;
}

export function RatingStar({ size }: RatingStarProps) {
	return (
		<svg width={size} height={size} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9.44368 14.4709L13.5937 16.9809C14.3537 17.4409 15.2837 16.7609 15.0837 15.9009L13.9837 11.1809L17.6537 8.00094C18.3237 7.42094 17.9637 6.32094 17.0837 6.25094L12.2537 5.84094L10.3637 1.38094C10.0237 0.570938 8.86368 0.570938 8.52368 1.38094L6.63368 5.83094L1.80368 6.24094C0.923676 6.31094 0.563676 7.41094 1.23368 7.99094L4.90368 11.1709L3.80368 15.8909C3.60368 16.7509 4.53368 17.4309 5.29368 16.9709L9.44368 14.4709Z"
				fill="currentColor"
			/>
		</svg>
	);
}
